import { render, staticRenderFns } from "./MesaObrasVisadoParcelarioConsultas.vue?vue&type=template&id=21fd4b06&"
import script from "./MesaObrasVisadoParcelarioConsultas.vue?vue&type=script&lang=js&"
export * from "./MesaObrasVisadoParcelarioConsultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports